import React from 'react'

function useOnKeydown(targetKey: string, fn: Function) {
  React.useEffect(() => {
    function downHandler({ key }: { key: string }) {
      if (key === targetKey) {
        fn()
      }
    }

    window.addEventListener('keydown', downHandler)

    return () => {
      window.removeEventListener('keydown', downHandler)
    }
  }, [targetKey, fn])
}

export { useOnKeydown }